import { t } from 'ember-intl'
import SideNavItem from 'teacher-ui-client/components/side-nav/item'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'
import type { TOC } from '@ember/component/template-only'

export const WritingIdeasLink: TOC<unknown> = <template>
  <SideNavItem data-test-side-nav-writing-ideas @linkTo="subscription-type.writing-ideas" @overrideDisabled={{true}}>
    <SideNavIconComponent @phosphorIcon="phosphor-lightbulb-fill" />
    <span>{{t "sideNav.writing.writingIdeas"}}</span>
  </SideNavItem>
</template>

export default WritingIdeasLink
